import React from 'react';
import axios from 'axios';
import { Box, Button, makeStyles } from '@material-ui/core';
import { Link } from "react-router-dom";

import {
    api
} from "../../Helper";
const useStyles = makeStyles((theme) => ({
  ctaBar: {
    width: '100%',
    backgroundColor: '#ffeaae',
    color: 'black',
    textAlign: 'center',
    padding: '16px',
    fontSize: '1.2rem',
    fontFamily: 'SANS-SERIF',
    letterSpacing: '0.1rem',
    position: 'fixed',
    top: 0,
    zIndex: theme.zIndex.appBar + 1,
  },
   button: {
    marginLeft: theme.spacing(2),
	fontWeight:'bold'
  },
      button1: {
      padding: '8px 12px',
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#e7be46",
        transform: "translateY(-2px)",
      },
    },
	    individualButton: {
        backgroundColor: '#f9bb02',
        borderRadius: '50px',
        color: 'black',
        fontSize: '1.2rem',
        marginLeft: '16px',
        fontWeight: '600',
        padding: '4px 16px',
        border: 'none',
        fontFamily: 'MyCustomFont, sans-serif',
        '&:hover': {
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
            backgroundColor: "#e7be46",
            transform: "translateY(-2px)",
            cursor: 'pointer',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.9rem',
        padding: '6px 6px',
        },
    },
}));

const StaticCTA = () => {
  const classes = useStyles();


	const sendPdf = () => {
		axios.post(
			api + '/send-pdf-mail',
			new URLSearchParams({
				name: "Vinod",
				email: "anshurk1@gmail.com"
			}),
			{
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}
		)
		.then((response) => {
			console.log("Email sent:", response.data);
		})
		.catch((error) => {
			console.error("Error sending email:", error);
		});
	};

	const downloadPdf = () => {
		const link = document.createElement('a');
		link.href = '/assets/pdf/lead-gen-automation-playbook.pdf';
		link.download = 'share.pdf';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};


  return (
    <Box className={classes.ctaBar}>
      Lead Generation Automation Playbook
 
	  <Button
		variant="contained"
              component={Link}
			  to="/avail-services"
        className={classes.individualButton}
        //onClick={sendPdf}
        >
        Download Now
        </Button>
    </Box>
  );
};

export default StaticCTA;
